import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchInventoryAuditLogs as fetchInventoryAuditLogsRoutine,
  fetchInventoryAuditLogsSearchOptions as fetchInventoryAuditLogsSearchOptionsRoutine
} from './routines';

export const fetchInventoryAuditLogs = ({ payload: qs }) =>
  sagaRoutineRequest(fetchInventoryAuditLogsRoutine, {
    request: () => call(Api.fetchInventoryAuditLogs, { qs })
  });

export const fetchInventoryAuditLogsSearchOptions = ({ payload: qs }) =>
  sagaRoutineRequest(fetchInventoryAuditLogsSearchOptionsRoutine, {
    request: () => call(Api.fetchInventoryAuditLogsSearchOptions, { qs })
  });
